import { clearGoogleSession } from "./googleSession";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { removeLoginLS } from "@delibrandev/utils";
import { apiRest } from "../api/constants";
import { logout } from "../api/requests";
import { setAlert, setLogoutPending, setUserLogOut } from "../reducers/userConfigSlice";
import { publishLogout } from "./shopSession";

let pendingLogout;
export function useShopLogout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loggingOut = useSelector((state) => state.aplicationConfig.userConfig.logoutPending);
  const logOff = () => {
    if (pendingLogout) return pendingLogout;
    dispatch(setLogoutPending(true));
    pendingLogout = (async () => {
      try {
        const response = await logout();
        if (!response || response.error !== false) throw new Error("Logout not confirmed");
        clearGoogleSession();
        removeLoginLS(apiRest);
        dispatch(setUserLogOut());
        publishLogout();
        navigate("/login", { replace: true });
        dispatch(setAlert({ type: "success", title: "Sesión cerrada", message: "Has cerrado la sesión en esta tienda." }));
        return true;
      } catch {
        dispatch(setAlert({ type: "error", title: "No se pudo cerrar la sesión", message: "Comprueba la conexión y pulsa Salir para volver a intentarlo." }));
        return false;
      } finally {
        dispatch(setLogoutPending(false));
        pendingLogout = undefined;
      }
    })();
    return pendingLogout;
  };
  return { logOff, loggingOut };
}
